import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";

// import { InputContainer } from ".../../MoveOut.styled";
import cc from "../../assets/ccIcon.svg";
import { Label } from "../../screens/complaint/Complaint.styled";
import cvv from "../../assets/cvv.svg";
import CloseIcon from "../../assets/CloseIcon.svg";
import ThanksIcon from "../../assets/thanks.svg";
import styled from "styled-components";

import OtpInput from "react18-input-otp";

import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import paymentReceiptsStore from "../../stores/PaymentReceiptsStore";
import { NotifyError } from "../../utils/ShowError";
// import { BaseProps } from "../../src/components/move-inRegistrationTabs/interfaces";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import {
  ButtonsContainer,
  InfoContainer,
  TabContainer,
} from "../move-inRegistrationTabs/move-inTabs.styled";
import { Spinner, SpinnerRaw } from "../SpinnerRaw/SpinnerRaw";
import { NotifySuccess } from "../../utils/ShowSuccess";
import { Box } from "@mui/material";

const InputContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: #edf4f6;
    border: 1px solid #b6bfdc;
    margin: 0 0.5rem;
  }
`;

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  //   onVerify:any,
  onClose: any;
}

const NewRequest = ({ onClose }: Props) => {
  const nameValue = useRef<HTMLSelectElement | null>(null);
  const parcelId = useRef<HTMLInputElement | null>(null);
  const summaryTypeList = [
    {
      key: "CONNECTOR",
      value: General?.codeLabels["cm_ascreate_dropdown_uos"].label,
    },
    {
      key: "UOS",
      value: General?.codeLabels["cm_ascreate_dropdown_tenant"].label,
    },
    {
      key: "DEFAULT",
      value: General?.codeLabels["cm_ascreate_dropdown_default"].label,
    },
    {
      key: "PARCEL",
      value: General?.codeLabels["cm_ascreate_dropdown_plot"].label,
    },
  ];
  const [accSummary, setAccSummary] = useState("");
  const [parcelIdval, setParcelVal] = useState("");
  const [loader, setLoader] = useState(false);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  
  const generateSummary = async () => {
    setLoader(true);
    if(accSummary === 'PARCEL'){
      if(parcelIdval !== ''){         //Loader conditioning
          
      }
    }
    else if(accSummary !== ''){
      
    }
    
    const parcelvalue = parcelId.current?.value;
    const acctype = nameValue.current?.value;
    const data = {
      parcelId: parcelvalue ? parcelvalue : null,
      personId: User?.profile?.personId ? User?.profile?.personId : null,
      userName: User.info.userName ? User.info.userName : null,
      accType: acctype,
    };
    const res = await paymentReceiptsStore?.generateRequest({
      errorId: "generateRequest",
      data,
    });
    const msg =
      res?.result?.cmGenerateAccountSummary_IWS?.cmTWStatusMsg?.toLowerCase();
    if (res?.message == "Success") {
      if (msg == "cm_msg_rep_acctsum_01") {
        NotifySuccess(General?.codeLabels['cm_as_label_successmsg']?.label?General?.codeLabels['cm_as_label_successmsg']?.label:"Request Created Successfully");
      } else {
        NotifyError(General?.codeLabels[msg]?.label);
      }
      onClose();
    }
    setLoader(false);
  };
  return (
    <Box
      sx={{
        width: "45%",
        overflow: "auto",
        margin: "auto",
        "@media screen and (max-width: 999px)": {
          width: "100%", // Adjust width for screens below 768px
          marginTop:'20%'
        },
        direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",
      }}
    >
      <div
        style={{
          // height: '20%',
          width: "100%",
          justifyContent: "space-between",
          padding: "1rem",
          background: "#101e8e",
          display: "flex",
          alignItems: "center",
          // '--bg-color': ColorAss ? ColorAss : 'pink',
        }}
        className="DynamicBgColor"
      >
        <h1
          style={{
            color: "#fff",
            justifySelf: "flex-start",
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {General?.codeLabels["cm_as_label_addbtn"]?.label}
        </h1>
        <img src={CloseIcon} alt="" onClick={onClose} />
      </div>

      <TabContainer
        style={{
          padding: "2rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          color: "#101e8e",
          width: "100%",
        }}
      >
        <Label
          style={{
            color: contrast?.contrastColor ? contrast?.contrastColor : "",
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
            height: "100px",
            width: "100%",
            display: "flex",
            // alignItems: "center",
            // width:'100%'
          }}
          className="DynamicTextColor"
        >
          {General?.codeLabels["cm_ascreate_label_astype"]?.label !== undefined
            ? General?.codeLabels["cm_ascreate_label_astype"]?.label
            : "Account Summary for"}
          *
          <select
            style={{
              color: "#101E8E",
              fontSize: `${General.accessibility.fontSize}rem`,
              width: "80%",
            }}
            onChange={(e) => setAccSummary(e.target.value)}
            value={accSummary}
            ref={nameValue}
            className="DynamicTextColor"
          >
            <option selected={true} disabled>
            {General?.codeLabels["cm_pdc_select"]?.label? General?.codeLabels["cm_pdc_select"]?.label: "Select"}
            </option>
            {summaryTypeList?.map((item: any) => (
              <option key={item?.key} value={item?.key}>
                {item?.value}
              </option>
            ))}
          </select>
        </Label>
        {nameValue?.current?.value == "PARCEL" && (
          <Label
            style={{
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "16px",
              gap: "0.5rem",
              height: "100px",
              position: "relative",
              width: "100%",
            }}
          >
            {General?.codeLabels["cm_ascreate_label_parcelid"]?.label !==
            undefined
              ? General?.codeLabels["cm_ascreate_label_parcelid"]?.label
              : "Parcel ID"}
            *
            <input
              style={{
                // color: "#101E8E",
                fontSize: `${General.accessibility.fontSize}rem`,
                width: "80%",
                background: "white",
              }}
              value={parcelIdval}
              onChange={(e) => setParcelVal(e.target.value)}
              type="number"
              ref={parcelId}
            />
          </Label>
        )}
        <ButtonSecondary
          style={{
            width: "228px",
            height: "50px",
            fontWeight: "bold",
            fontSize: `${General.accessibility.fontSize}rem`,
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
            background: contrast?.contrastColor
              ? contrast?.contrastColor
              : "#101e83",
          }}
          onClick={generateSummary}
          className="DynamicButtonColor"
        >
          {loader ? (
            <Spinner width="30px" height="30px" />
          ) : (
            General?.codeLabels["cm_mob_download"]?.label
          )}
        </ButtonSecondary>
      </TabContainer>
    </Box>
  );
};

export default observer(NewRequest);
